import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader2, Mail } from "lucide-react";

export const EmailCopyDialog = ({ open, onOpenChange, onSend, busy, userEmail }) => {
  const [recipient, setRecipient] = useState("");
  const [note, setNote] = useState("");
  const send = async () => {
    const ok = await onSend({ recipient_email: recipient.trim() || null, note: recipient.trim() ? note.trim() || null : null });
    if (ok) { setRecipient(""); setNote(""); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm" data-testid="email-copy-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2"><Mail size={20} className="text-accent" /> Email a copy</DialogTitle>
          <DialogDescription>
            We'll send the completed PDF and filing packet to <span className="font-medium text-foreground">{userEmail}</span>, plus a secure download link.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="copy-recipient">Also send to (optional)</Label>
            <Input id="copy-recipient" type="email" placeholder="attorney@lawfirm.com" value={recipient}
              onChange={(e) => setRecipient(e.target.value)} data-testid="email-copy-recipient-input" />
            <p className="text-xs text-muted-foreground">Your attorney or a family member gets the attached files. The secure link stays with you.</p>
          </div>
          {recipient.trim() && (
            <div className="space-y-1.5">
              <Label htmlFor="copy-note">Short note</Label>
              <Textarea id="copy-note" maxLength={500} rows={3} placeholder="Here's the completed form we talked about."
                value={note} onChange={(e) => setNote(e.target.value)} data-testid="email-copy-note-input" />
              <p className="text-xs text-muted-foreground text-right">{note.length}/500</p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="email-copy-cancel">Cancel</Button>
          <Button onClick={send} disabled={busy} data-testid="email-copy-send" className="rounded-sm gap-2">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />} {busy ? "Sending…" : "Send"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
